import React, { useContext, useMemo, useState } from 'react';

import {
  BAFilterDataType,
  BAFilterSchema,
  BAFilterSchemaInitialValues,
} from '../../../models/dashboard/filter-forms/ba-filter.model';
import FormButtonArea from '../../Button/FormButtonArea';
import { FormSubmitButton } from '../../Button/FormSubmitButton';
import ResetFormSubmitButton from '../../Button/ResetFormSubmitButton';
import { CustomDatePicker } from '../../FormCom/CustomDatePicker';
import {
  CustomStackedPlainRadio,
  CustomStackedPlainRadioFieldGroup,
} from '../../FormCom/CustomStackedPlainRadioField';
import FieldCollapseGroup from '../../FormCom/FieldCollapseGroup';
import { FormComponent } from '../../FormCom/FormComponent';
import { TableContext } from '../TableContext';

interface BAFilterProps {}

const BAFilterForm: React.FC<BAFilterProps> = () => {
  const tableContext = useContext(TableContext);
  const [formInitialState, setFormInitialState] = useState({});

  useMemo(() => {
    setFormInitialState({
      ...BAFilterSchemaInitialValues,
      ...tableContext?.tableSelectedFilter,
    });

    // eslint-disable-next-line
  }, []);

  if (Object.keys(formInitialState).length === 0) {
    return <div>'...'</div>;
  }

  const handleOnSubmit = (values: BAFilterDataType) => {
    tableContext?.setTableSelectedFilter(values);
    tableContext?.handleSetTableFilterRecord({
      ...values,
      page: 0,
    });
  };

  return (
    <FormComponent
      initialValues={formInitialState}
      schema={BAFilterSchema}
      onSubmit={handleOnSubmit}
    >
      <FieldCollapseGroup title='Processing Status'>
        <CustomStackedPlainRadioFieldGroup name='status' className='large'>
          <CustomStackedPlainRadio
            name='status'
            value='Pending'
            className='hug'
          >
            Pending
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='status'
            value='Processed'
            className='hug'
          >
            Processed
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='status'
            value='Rejected'
            className='hug'
          >
            Rejected
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='status'
            value='Confirmed'
            className='hug'
          >
            Confirmed
          </CustomStackedPlainRadio>
        </CustomStackedPlainRadioFieldGroup>
      </FieldCollapseGroup>

      <FieldCollapseGroup title='Date'>
        <CustomDatePicker
          label='Start Date'
          placeholder='select start date'
          name='startDate'
          id='startDate'
        />

        <CustomDatePicker
          label='End Date'
          placeholder='select end date'
          name='endDate'
          id='endDate'
        />
      </FieldCollapseGroup>

      <FormButtonArea>
        <ResetFormSubmitButton isTableReset={true}>
          Clear filters
        </ResetFormSubmitButton>
        <FormSubmitButton btnType='submit'>Apply Filter</FormSubmitButton>
      </FormButtonArea>
    </FormComponent>
  );
};

export default BAFilterForm;
